import { render, staticRenderFns } from "./PartnershipA.vue?vue&type=template&id=676cfe4e&scoped=true"
import script from "./PartnershipA.vue?vue&type=script&lang=js"
export * from "./PartnershipA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676cfe4e",
  null
  
)

export default component.exports